<div class="stepper-footer-container" [class.stepper-footer-reverse]="reverse" [class.stepper-footer-center]="center">
  <ng-content></ng-content>
</div>
